// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__G2FMP","hero_alt":"hero_hero_alt__+tgjh","porch":"hero_porch__7Xm6V","hero_title":"hero_hero_title__1juqv","home":"hero_home__XX1sw"};